import { useCallback, useEffect, useRef } from "react";

// How long the admin may pause typing before a picker searches the server.
export const SEARCH_DELAY = 400;

// The page size the pickers load (the first page by name, or the matches of
// the typed text).
export const PICKER_PAGE_SIZE = 1000;

// A debounced search for pickers that load only the first page of a list:
// returns a handler for the field's typed filter that calls search(term) once
// the admin stops typing, with "" when the filter is emptied (E2E25).
export const useServerSearch = (search, delay = SEARCH_DELAY) => {
  const timer = useRef(null);
  const latestSearch = useRef(search);
  latestSearch.current = search;

  useEffect(() => () => clearTimeout(timer.current), []);

  return useCallback(
    (term) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => latestSearch.current(term || ""), delay);
    },
    [delay]
  );
};

// The search results plus the field's current selection(s) the results do not
// include, so a chosen option still shows after a search narrowed the list.
export const withSelected = (options, selected) => {
  const chosen = (Array.isArray(selected) ? selected : [selected]).filter(
    (item) => item && item.id !== undefined && item.id !== null
  );
  const missing = chosen.filter(
    (item) => !options.some((option) => option.id === item.id)
  );
  return missing.length ? [...missing, ...options] : options;
};
